import { render, staticRenderFns } from "./VariationColorComponent.html?vue&type=template&id=b381654c&"
import script from "./VariationColorComponent.js?vue&type=script&lang=js&"
export * from "./VariationColorComponent.js?vue&type=script&lang=js&"
import style0 from "./VariationColorComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports